import React, { useEffect, useState, useRef } from 'react';
import './LockIt.css';

const LockIt = React.forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const features = [
    { icon: '🔐', title: 'Segurança Total', desc: 'Criptografia de ponta a ponta' },
    { icon: '📝', title: 'Notas Privadas', desc: 'Guarde suas anotações com segurança' },
    { icon: '🔑', title: 'Senhas', desc: 'Gerenciador de senhas integrado' },
    { icon: '💳', title: 'Cartões', desc: 'Armazene dados de cartões com segurança' },
    { icon: '📧', title: 'E-mails', desc: 'Organize seus e-mails importantes' },
    { icon: '🎯', title: 'Organização', desc: 'Interface intuitiva e fácil de usar' }
  ];

  return (
    <section ref={(el) => { sectionRef.current = el; if (ref) ref.current = el; }} className="lockit">
      <div className="lockit-background"></div>
      
      <div className="container">
        <div className={`lockit-content ${isVisible ? 'visible' : ''}`}>
          <div className="project-header">
            <div className="project-badge">App Mobile</div>
            <h2 className="project-title">LockIt</h2>
            <p className="project-subtitle">
              Seu cofre digital pessoal. Guarde informações sensíveis com segurança máxima.
            </p>
          </div>

          <div className="project-showcase">
            <div className="phone-mockup">
              <div className="phone-frame">
                <div className="phone-notch"></div>
                <div className="phone-screen">
                  <div className="app-preview lockit-preview">
                    <div className="preview-icon">🔒</div>
                    <h3>LockIt</h3>
                    <p>Suas informações protegidas</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="features-grid">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="feature-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="feature-icon">{feature.icon}</div>
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="tech-stack">
            <h3>Tecnologias Utilizadas</h3>
            <div className="tech-tags">
              <span className="tech-tag">React Native</span>
              <span className="tech-tag">JavaScript</span>
              <span className="tech-tag">Async Storage</span>
              <span className="tech-tag">Criptografia</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default LockIt;
